import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito saber mucho de matemáticas?',
    a: 'No. BetIQ está diseñado para que cualquier persona pueda usarlo paso a paso, incluso si empieza desde cero.'
  }, {
    q: '¿Cuánto capital necesito para empezar?',
    a: 'Puedes empezar con el capital que tengas. El sistema incluye gestión de bankroll para adaptarse a tu nivel.'
  }, {
    q: '¿Funciona para cualquier liga?',
    a: 'Sí. BetIQ te enseña a analizar partidos en diferentes ligas usando el mismo sistema.'
  }, {
    q: '¿Es un grupo de señales o picks?',
    a: 'No. BetIQ no te dice qué apostar. Te enseña cómo analizar y tomar tus propias decisiones.'
  }, {
    q: '¿Cuándo obtengo acceso?',
    a: 'El acceso es inmediato. Después de tu compra puedes empezar a usar BetIQ el mismo día.'
  }];
  return <section className="w-full py-20 px-4 bg-brand-alt border-y border-brand-card" data-id="element-60">
      <div className="max-w-3xl mx-auto" data-id="element-61">
        <h2 className="text-3xl md:text-4xl text-center text-brand-text mb-12" data-id="element-62">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-63">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-64" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-brand-card border border-brand-gold/10 rounded-lg overflow-hidden transition-all duration-200" data-id="element-65">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-66">
        <span className="font-heading text-xl text-brand-text" data-id="element-67">{question}</span>
        <ChevronDownIcon className={`w-5 h-5 text-brand-gold transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-68" />
      </button>

      <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-69">
        <p className="text-brand-muted text-lg" data-id="element-70">{answer}</p>
      </div>
    </div>;
}